import React, { useEffect } from 'react';
import styled from 'styled-components';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button } from '../Buttons';

export function GeneratePdfButton({ sectionId, label, generateDirectly, closeModal, setLoading }) {
  const pxToMm = px => Math.floor(px / document.getElementById('myMm').offsetHeight);
  const mmToPx = mm => document.getElementById('myMm').offsetHeight * mm;
  const range = (start, end) => Array.from({ length: end - start }, (_, id) => id + start);

  const generate = () => {
    if (setLoading) {
      setLoading(true);
    }
    
    const input = document.getElementById(sectionId);
    const inputHeightMm = pxToMm(input.offsetHeight);
    const a4HeightMm = 297;
    const a4HeightPx = mmToPx(a4HeightMm);
    const numPages = inputHeightMm <= a4HeightMm ? 1 : Math.floor(inputHeightMm / a4HeightMm) + 1;

    console.log({ input, inputHeightMm, a4HeightMm, a4HeightPx, numPages, inputHeightPx: input.offsetHeight });

    html2canvas(input, {
      scale: 2, // Adjust the scale for better resolution
      useCORS: true, // Ensure cross-origin images are handled
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('pt', 'mm');
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      // Add the first image
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add remaining pages
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const pdfBlob = pdf.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      
      if (setLoading) {
        setLoading(false);
        closeModal();
      }
    }).catch(error => {
      console.error("Error generating canvas:", error);
      if (setLoading) {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (generateDirectly) {
      generate();
    }
  }, [generateDirectly]);

  return (
    <div id="myMm" style={{ height: '1mm' }}>
      <Button onClick={generate}>
        {label}
      </Button>
    </div>
  );
}
